import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

import logo from '../images/logo.svg'

const HeaderWrapper = styled.div`
  background: #524763;
  img {
    margin-bottom: 0;
  }
`

const HeaderContainer = styled.div`
  margin: 0 auto;
  max-width: 960px;
  padding: 0.3rem;
`

const Header = ({ siteTitle }) => (
  <HeaderWrapper>
    <HeaderContainer>
      <h1 style={{ margin: 0, display: 'inline-block' }}>
        <Link
          to="/"
          style={{
            color: 'white',
            textDecoration: 'none',
            display: 'inline-block',
          }}
        >
          <img
            style={{
              width: '100px',
            }}
            src={logo}
            alt="Level Up Tutorials Logo"
          />
        </Link>     
      </h1>
      <Link to="team"
        style={{
          color: 'white',
          textDecoration: 'none',
          display: 'inline-block',
          marginLeft: '20px',
        }}>Team</Link>
      <Link to="about"
        style={{
          color: 'white',
          textDecoration: 'none',
          display: 'inline-block',
          marginLeft: '20px',
        }}>About</Link>
    </HeaderContainer>
  </HeaderWrapper>
)

export default Header
